// Image values may be a legacy plain URL string OR an object { url, position, zoom }.
// These helpers read them uniformly so display components can position/zoom photos.

const BACKEND = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
const FILES_MARKER = "/api/files/";

// Always resolve uploaded-file URLs to the CURRENT backend, so images work
// across preview, deploy and custom domains and are never hard-baked to the
// (auth-gated) preview host. External URLs (Unsplash, data/blob) pass through.
export const resolveUrl = (u) => {
  if (!u || typeof u !== "string") return "";
  const i = u.indexOf(FILES_MARKER);
  if (i !== -1) return `${BACKEND}${FILES_MARKER}${u.slice(i + FILES_MARKER.length)}`;
  if (/^(https?:|data:|blob:)/i.test(u)) return u;
  return `${BACKEND}${FILES_MARKER}${u.replace(/^\/+/, "")}`;
};

export const imgSrc = (v) => resolveUrl(typeof v === "string" ? v : v?.url || "");
export const imgPos = (v) => (v && typeof v === "object" && v.position ? v.position : "50% 50%");
export const imgZoom = (v) => (v && typeof v === "object" && typeof v.zoom === "number" ? v.zoom : 1);

// Inline style for an <img className="object-cover"> (or bg layer) to apply focal + zoom.
export const imgStyle = (v) => {
  const position = imgPos(v);
  const zoom = imgZoom(v);
  return { objectPosition: position, transform: `scale(${zoom})`, transformOrigin: position };
};
